import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

export const StyledErrorBannerFlex = styled(Flex)<{ $variant: "error" | "warning" }>`
    padding: 10px 16px;
    border-radius: 4px;
    background-color: ${({ $variant }) =>
        $variant === "error" ? colorsPalettes.red["100"] : colorsPalettes.bluegrey["200"]};
`;

export const StyledErrorBannerText = styled.div<{ $variant: "error" | "warning" }>`
    display: flex;
    align-items: center;
    gap: 8px;
    ${setFontVariant("caption")};
    color: ${({ $variant }) => ($variant === "error" ? colorsPalettes.red["500"] : colorsPalettes.carbon["400"])};
`;
